<template>
  <v-row>
    <v-col class="col-8">
      <v-card>
        <v-card-title>
          <h2>
            {{ $t('reportsOverview.bookings') }}
          </h2>
        </v-card-title>

        <v-card-text>
          <v-form ref="accountingExportForm" v-model="accountingExportValid">
            <v-row>
              <v-col class="col-4 pb-0">
                <s-date-picker
                  :date.sync="exportDates.from"
                  :label="$t('reportsOverview.from')"
                  :rules="[
                    (v) => !!v || $t('reportsOverview.required'),
                    (v) =>
                      validateFromTo(
                        exportDates.from,
                        exportDates.to,
                        'from'
                      ) || $t('reportsOverview.lessOrEquals'),
                  ]"
                />
              </v-col>
              <v-col class="col-4 pb-0">
                <s-date-picker
                  :date.sync="exportDates.to"
                  :label="$t('reportsOverview.to')"
                  :rules="[
                    (v) => !!v || $t('reportsOverview.required'),
                    (v) =>
                      validateFromTo(exportDates.from, exportDates.to, 'to') ||
                      $t('reportsOverview.moreOrEquals'),
                  ]"
                />
              </v-col>

              <v-col class="col-4 text-center pt-4">
                <v-btn
                  color="primary"
                  :disabled="!accountingExportValid"
                  large
                  outlined
                  @click="
                    bookingExcelExporter.downloadAccountingExcel(
                      new Date(exportDates.from),
                      new Date(exportDates.to),
                      $options
                    )
                  "
                >
                  <span class="fal fa-file-excel mr-2" />
                  {{ $t('reportsOverview.export') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SDatePicker from '../../../components-shared/utils/SDatePicker'
import BookingExcelExport from '../../../classes-internal/reports/BookingExcelExport'

export default {
  name: 'AccountingExport',
  components: { SDatePicker },
  props: {
    bookingExcelExporter: {
      type: BookingExcelExport,
      required: true,
    },
  },
  data() {
    return {
      exportDates: {
        from: null,
        to: null,
      },
      accountingExportValid: false,
    }
  },

  watch: {
    exportDates: {
      deep: true,
      handler() {
        this.$refs.accountingExportForm.validate()
      },
    },
  },

  methods: {
    validateFromTo(from, to, field = 'from') {
      if (field === 'from' && !to) {
        return true
      }

      if (field === 'to' && !from) {
        return true
      }

      return new Date(from) <= new Date(to)
    },
  },
}
</script>
